module.exports = __webpack_public_path__ + "static/img/pdpbanneroverlay.4ac5ac2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pdpbanneroverlay.png
// module id = 2301
// module chunks = 14